import React from 'react';
import { Select, Icon, Checkbox, Tooltip, Input } from 'antd';
import {
  Sidebar,
  SidebarTitle,
  PreviewSection,
  PreviewTitle,
  ButtonRow,
  DownloadButton,
  RowSection,
  InsertContainer,
  UploadButton,
  ShiftContainer,
  Prefix,
  DocumentListTitle,
  DocumentList,
  DocumentItem,
  DocumentHeader,
  DocumentTitle,
  DocumentAddress,
  DocumentMeta,
  PaginationContainer,
  PageNavButton,
  PageDisplay,
  PageText,
} from '../HybridMailStyles';
import { HYBRID_MAIL } from '../TranslationValue';
import { useHybridMail } from '../HybridMailContext';
import { useMemo } from 'react';
import { debounce } from 'underscore';

const { Option } = Select;

const SidebarContent = ({ hybridInfo }) => {
  const {
    isPreview,
    isLoading,
    handleStationaryOrPreview,
    isValidPos,
    selectedFile,
    handleSendLetter,
    envelopeType,
    envelopeTypeChange,
    deliveryClass,
    deliveryClassChange,
    selectedStationery,
    handleStationery,
    stationeryList,
    selectedInsert,
    handleInsert,
    insertList,
    fileInputRef,
    handleInsertClick,
    handleFileChange,
    shiftAll,
    handleApplyAllShift,
    shiftUnit,
    handleShiftUnit,
    shiftAllVal,
    shiftSize,
    selectedBatchDetailId,
    handleShitContent,
    addressBlocks,
    handleNavigation,
    itemRefs,
    uploadLoading,
    showRefresh,
    handleRefreshList,
    t,
    currentPage,
    setCurrentPage,
    totalPages,
    totalRecords,
    handleOnChangePage,
    handleInputSearch,
  } = useHybridMail();

  const shiftVales = ['10', '20', '50', '100'];

  const debouncedSearch = useMemo(
    () => debounce(handleInputSearch, 500),
    [handleInputSearch]
  );

  return (
    <Sidebar>
      <SidebarTitle>
        {t(HYBRID_MAIL.SIDE_BAR_TITLE.key, HYBRID_MAIL.SIDE_BAR_TITLE.value)}
      </SidebarTitle>

      <PreviewSection>
        <PreviewTitle>
          {t(
            HYBRID_MAIL.CONFIGURE_LETTER_SETTINGS.key,
            HYBRID_MAIL.CONFIGURE_LETTER_SETTINGS.value,
          )}
        </PreviewTitle>

        <ButtonRow>
          <DownloadButton
            id={'more-options-download'}
            className="preview"
            onClick={handleStationaryOrPreview}
            disabled={isPreview || isLoading}
          >
            <Icon type="eye" theme="filled" style={{ paddingRight: '12px' }} />
            {t(HYBRID_MAIL.PREVIEW.key, HYBRID_MAIL.PREVIEW.value)}
          </DownloadButton>
          <DownloadButton
            id={'hrbrid-send-letter'}
            className="preview"
            onClick={handleSendLetter}
            disabled={isPreview || isLoading}
          >
            {t(HYBRID_MAIL.PROCESS_BATCH.key, HYBRID_MAIL.PROCESS_BATCH.value)}
          </DownloadButton>
        </ButtonRow>
        <RowSection isPreview={1} marginTop>
          <span style={{ color: 'white', fontSize: '15px' }}>
            {t(HYBRID_MAIL.ENVELOPE_TYPE.key, HYBRID_MAIL.ENVELOPE_TYPE.value)}
            &nbsp; &nbsp;
          </span>
          <Select
            optionFilterProp="children"
            value={envelopeType}
            style={{ minWidth: '50%' }}
            onChange={envelopeTypeChange}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={isPreview || isLoading}
          >
            <Option value="DL">DL</Option>
            <Option value="C5">C5</Option>
            <Option value="C4">C4</Option>
          </Select>
        </RowSection>
        <RowSection isPreview={1} marginTop>
          <span style={{ color: 'white', fontSize: '15px' }}>
            {t(HYBRID_MAIL.DELIVERY_CLASS.key, HYBRID_MAIL.DELIVERY_CLASS.value)}
            &nbsp; &nbsp;
          </span>
          <Select
            optionFilterProp="children"
            value={deliveryClass}
            style={{ minWidth: '50%' }}
            onChange={deliveryClassChange}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={isPreview || isLoading}
          >
            <Option value="First Class">
              {t(HYBRID_MAIL.FIRST_CLASS.key, HYBRID_MAIL.FIRST_CLASS.value)}
            </Option>
            <Option value="Standard Class">
              {t(HYBRID_MAIL.STANDARD_CLASS.key, HYBRID_MAIL.STANDARD_CLASS.value)}
            </Option>
          </Select>
        </RowSection>
        <RowSection isPreview={1} marginTop>
          <span style={{ color: 'white', fontSize: '15px' }}>
            {t(HYBRID_MAIL.STATIONARY.key, HYBRID_MAIL.STATIONARY.value)}
            &nbsp; &nbsp;
          </span>
          <Select
            optionFilterProp="children"
            value={selectedStationery}
            style={{ minWidth: '50%', maxWidth: '50%' }}
            onChange={handleStationery}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={isPreview || isLoading}
          >
            {stationeryList.map(item => (
              <Option key={item.blockId} value={item.blockId}>
                <Tooltip key={item.blockId} placement="topLeft" title={item.blockName}>
                  {item.blockName}
                </Tooltip>
              </Option>
            ))}
          </Select>
        </RowSection>

        <RowSection isPreview={1} marginTop>
          <span style={{ color: 'white', fontSize: '15px' }}>
            {t(HYBRID_MAIL.INSERT.key, HYBRID_MAIL.INSERT.value)}
            &nbsp; &nbsp;
          </span>
          <InsertContainer>
            <Select
              showSearch
              optionFilterProp="children"
              value={selectedInsert}
              style={{ minWidth: '77%', maxWidth: '77%' }}
              onChange={handleInsert}
              filterOption={(input, option) =>
                option.props.children.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              disabled={isPreview || isLoading}
            >
              {insertList.map((insert, index) => (
                <Option key={insert.id} value={insert.id} selected={insert.id === selectedInsert}>
                  <Tooltip
                    key={insert.id}
                    placement="topLeft"
                    title={insert.name.replace('.pdf', '')}
                  >
                    {insert.name.replace('.pdf', '')}
                  </Tooltip>
                </Option>
              ))}
            </Select>
            <Tooltip
              key={'insert_upload'}
              placement="topLeft"
              title={t(
                HYBRID_MAIL.TOOLTIP_UPLOAD_INSERT.key,
                HYBRID_MAIL.TOOLTIP_UPLOAD_INSERT.value,
              )}
            >
              <UploadButton onClick={handleInsertClick} disabled={isLoading || isPreview}>
                {uploadLoading ? <Icon type="loading" spin /> : <Icon type="upload" />}
              </UploadButton>
            </Tooltip>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              accept="application/pdf"
              onChange={handleFileChange}
            />
          </InsertContainer>
        </RowSection>

        <RowSection isPreview={1} marginTop>
          <span style={{ color: 'white', fontSize: '15px' }}>
            {t(HYBRID_MAIL.SHIFT_CONTENT.key, HYBRID_MAIL.SHIFT_CONTENT.value)}
            &nbsp;
            <Tooltip
              placement="top"
              title={t(
                HYBRID_MAIL.TOOLTIP_SHIFT_CONTENT.key,
                HYBRID_MAIL.TOOLTIP_SHIFT_CONTENT.value,
              )}
            >
              <Icon type="info-circle" style={{ fontSize: '12px' }} />
            </Tooltip>
          </span>
          <ShiftContainer>
            {/* <Prefix>
                  <Tooltip
                    placement="topLeft"
                    title={shiftAll ? t(HYBRID_MAIL.DISABLE_SHIFT_ALL.key, HYBRID_MAIL.DISABLE_SHIFT_ALL.value) : t(HYBRID_MAIL.APPLY_SHIFT_ALL.key, HYBRID_MAIL.APPLY_SHIFT_ALL.value)}
                  >
                    <Checkbox
                      onChange={handleApplyAllShift}
                      checked={shiftAll}
                      disabled={isPreview}
                    ></Checkbox>
                  </Tooltip>
                </Prefix> */}
            <Tooltip placement="topLeft" title={shiftAll ? shiftAllVal : shiftSize}>
              <Select
                mode="combobox"
                filterOption={false}
                className="shiftContent"
                value={shiftAll ? shiftAllVal : shiftSize}
                style={{ width: '100%', zIndex: 1 }}
                onChange={handleShitContent}
                // onInputKeyDown={handleShiftEnter}
                disabled={isPreview || isLoading}
                // suffix="Px"
              >
                {shiftVales.map((val, i) => (
                  <Option key={i} value={val} selected={val === shiftSize}>
                    <Tooltip key={i} placement="topLeft" title={val}>
                      {val}
                    </Tooltip>
                  </Option>
                ))}
              </Select>
            </Tooltip>
            <Select
              value={shiftUnit}
              className="shiftUnits"
              onChange={handleShiftUnit}
              disabled={isPreview || isLoading}
            >
              <Option value={'px'} selected={shiftUnit === 'px'}>
                {' '}
                px{' '}
              </Option>
              <Option value={'mm'} selected={shiftUnit === 'mm'}>
                {' '}
                mm{' '}
              </Option>
            </Select>
          </ShiftContainer>
        </RowSection>

        {addressBlocks.length > 0 && (
          <>
            <RowSection isPreview={1} marginTop>
              <DocumentListTitle>
                <span>
                  {t(HYBRID_MAIL.DOCUMENTS_SPLIT_BY.key, HYBRID_MAIL.DOCUMENTS_SPLIT_BY.value, {
                    criteria:
                      hybridInfo.splitOnCriteria === 'address'
                        ? t(
                            HYBRID_MAIL.SPLIT_CRITERIA_ADDRESS.key,
                            HYBRID_MAIL.SPLIT_CRITERIA_ADDRESS.value,
                          )
                        : t(
                            HYBRID_MAIL.SPLIT_CRITERIA_PAGE.key,
                            HYBRID_MAIL.SPLIT_CRITERIA_PAGE.value,
                          ),
                  })}
                </span>
                {!showRefresh && (
                  <span>
                    <Icon type="reload" onClick={() => handleRefreshList(undefined)} />
                  </span>
                )}
              </DocumentListTitle>
            </RowSection>
            <Input
              onInput={e => debouncedSearch(e.target.value)}
              prefix={<Icon type="search" />}
              placeholder={t(
                HYBRID_MAIL.SEARCH_LETTER_PLACEHOLDER.key,
                HYBRID_MAIL.SEARCH_LETTER_PLACEHOLDER.value,
              )}
            />
            {showRefresh && !!totalPages && totalPages > 1 && (
              <PaginationContainer>
                <PageNavButton
                  onClick={() => handleOnChangePage('prev')}
                  disabled={Number(currentPage) <= 1 || currentPage === ''}
                >
                  <Icon type="left" />
                </PageNavButton>
                <PageDisplay>
                  <PageText>{t(HYBRID_MAIL.PAGE_LABEL.key, HYBRID_MAIL.PAGE_LABEL.value)}</PageText>
                  <Input
                    name="pageNumber"
                    id="pageNumber"
                    value={currentPage}
                    onChange={e => handleOnChangePage('input', e.target.value)}
                  />
                  <PageText>
                    {t(HYBRID_MAIL.OF_LABEL.key, HYBRID_MAIL.OF_LABEL.value)}{' '}
                    {totalPages.toLocaleString()}
                  </PageText>
                </PageDisplay>
                <PageNavButton
                  onClick={() => handleOnChangePage('next')}
                  disabled={currentPage === '' || Number(currentPage) === totalPages}
                >
                  <Icon type="right" />
                </PageNavButton>
              </PaginationContainer>
            )}
            <DocumentList>
              {addressBlocks.map((block, index) => {
                const lines = block.addressBlock?.text ? block.addressBlock?.text?.split('\n') : [];
                const title =
                  lines?.length > 0
                    ? lines[0]
                    : t(HYBRID_MAIL.UNTITLED_DOCUMENT.key, HYBRID_MAIL.UNTITLED_DOCUMENT.value);
                const address = lines.slice(1).join('\n');
                const pageDifference = block.endPage - block.startPage;
                const pageCount = pageDifference > 0 ? pageDifference + 1 : 1;

                return (
                  <DocumentItem
                    key={block.batchDetailId}
                    disabled={isLoading}
                    // ref={el => (itemRefs.current[index] = el)}
                    selected={selectedBatchDetailId === block.batchDetailId}
                    onClick={() => handleNavigation('click', block.batchDetailId)}
                  >
                    <DocumentHeader>
                      <Icon type="mail" />
                      <DocumentTitle>{title}</DocumentTitle>
                    </DocumentHeader>
                    {address && <DocumentAddress>{address}</DocumentAddress>}
                    {/* <DocumentMeta>
                      <span>{new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                      <span>{pageCount} page</span>
                    </DocumentMeta> */}
                  </DocumentItem>
                );
              })}
            </DocumentList>
          </>
        )}
      </PreviewSection>
    </Sidebar>
  );
};

export default SidebarContent;
